import { makeAutoObservable } from 'mobx'
import { storeMobx, cartMobx } from 'restaurant'
import { decorationMobx } from '@mobxStore'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import { find } from '@dt/fe-utils/dist/lodash'

class EatTypeStatusStore {
  constructor () {
    makeAutoObservable(this)
  }

  /** 可否切换就餐方式 */
  get disableSwitchEatType () {
    return !!cartMobx.ordersId && !!cartMobx.info.payMode
  }

  /** 可用就餐方式列表 */
  get enableEatTypeList (): TEatType[] {
    const { eatTypeEntries = [] } = decorationMobx
    const { pauseMobileOrderTime, pauseSelfDeliveryOrderTime, pauseReserveOrderTime, pausePickupOrderTime } = storeMobx.info || {}
    if (pauseMobileOrderTime?.all) {
      return []
    }

    if (Config.codeType === 'brand') {
      if (pauseMobileOrderTime?.togo) {
        return []
      }
      return [TEEatType.dinein, TEEatType.pickup, TEEatType.delivery].map(eatTypeEntry => {
        return (eatTypeEntry === TEEatType.dinein && !pauseReserveOrderTime?.status && storeMobx.info.openDinein) || (eatTypeEntry === TEEatType.pickup && !pausePickupOrderTime?.status && storeMobx.info.openPickup) || (eatTypeEntry === TEEatType.delivery && !pauseSelfDeliveryOrderTime?.status && storeMobx.info.openSelfDelivery) ? eatTypeEntry : null
      }).filter(Boolean)
    } else {
      return !pauseReserveOrderTime?.status && storeMobx.info.openDinein ? [TEEatType.dinein, TEEatType.togo] : []
    }
  }

  /** 是否有可用就餐方式 */
  get hasEnableEatType (): boolean {
    return !!this.enableEatTypeList.length
  }

  /** 是否有可用就餐方式 */
  get canUseEatType (): boolean {
    return !!find(this.enableEatTypeList, (item) => cartMobx.info.eatType === item)
  }

  /**
   * 判断就餐方式是否可用
   * @eatType 就餐方式
  */
  // 判断可使用就餐方式, 只有当品牌码才需要判断
  isEatTypeEnable (eatType: TEatType) {
    return Config.codeType === 'brand' ? this.hasEnableEatType && this.enableEatTypeList.includes(eatType) : true
  }

  /** 验证当前门店是否支持此就餐方式 eatType, isPause 是否要判断暂时关闭  */
  checkBrandEatTypeInStore (eatType: TEatType, isPause?: boolean) {
    // 判断是否有暂停，pos全部关闭，或者关闭手机点单就直接退出
    if (isPause && (storeMobx.info?.pauseMobileOrderTime?.all || storeMobx.info?.pauseMobileOrderTime?.togo)) {
      return false
    }
    if (this.checkHasEatTypeInStore(storeMobx.info, eatType) && (!isPause || this.checkHasEatTypePauseInStore(storeMobx.info, eatType))) {
      return true
    }
    return false
  }

  /** 判断门店是否暂停当前就餐方式 */
  checkHasEatTypePauseInStore (store, eatType) {
    // 未开启外卖
    if (Config.codeType === 'brand' && eatType === TEEatType.delivery && store?.pauseSelfDeliveryOrderTime?.status) {
      return false
    }
    // 未开启品牌码堂食
    if (Config.codeType === 'brand' && eatType === TEEatType.dinein && store?.pauseReserveOrderTime?.status) {
      return false
    }
    // 未开启品牌码自提
    if (Config.codeType === 'brand' && eatType === TEEatType.pickup && store?.pausePickupOrderTime?.status) {
      return false
    }
    return true
  }

  /** 判断门店是否开通当前就餐方式 */
  checkHasEatTypeInStore (store, eatType) {
    // 未开启外卖
    if (Config.codeType === 'brand' && eatType === TEEatType.delivery && !store.openSelfDelivery) {
      return false
    }
    return true
  }
}

export default new EatTypeStatusStore()
